import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation,Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import './index.css';

const TripleSwiper = () => {
    const slides = [{img: require('../../assets/Triple-1.png')},
    {img: require('../../assets/Triple-2.png')},
    {img: require('../../assets/Triple-3.png')},
    {img: require('../../assets/Triple-4.png')},
    ]
  return (
    <div className="triple-swiper-container">
      <Swiper
        modules={[Navigation,Pagination]}
        slidesPerView={3}
        spaceBetween={30}
        loop={true}
        navigation={{
          nextEl: '.triple-next',
          prevEl: '.triple-prev',
        }}
        pagination={{
            el: '.triple-pagination',
            clickable: true,
            bulletClass: 'triple-bullet',
            bulletActiveClass: 'triple-bullet-active'
          }}
        breakpoints={{
          320: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 }
        }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <div className="triple-slide">
              <img 
                src={slide.img} 
                alt={`Slide ${index + 1}`}
                className="triple-image"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="triple-pagination"></div>

      <div className="triple-navigation">
        <img
          className="triple-prev"
          src={require('../../assets/left-icon.png')}
          alt="prev"
          role="button"
        />
        <img
          className="triple-next"
          src={require('../../assets/right-icon.png')}
          alt="next"
          role="button"
        />
      </div>
    </div>
  );
};

export default TripleSwiper;